import React from 'react';

const Home: React.FC = () => {
  return (
    <div>
      <p>Hi! I’m a product manager, engineer, and multidisciplinary artist soon-to-be-based in NYC. I’ve been building tech in some form for almost 15 years now, starting with my first attempt at a ‘startup’ when I was 12. I bloodied myself on hackathons in college, then dropped out after my sophomore year to do Y Combinator in summer of 2015. I’ve been doing things in and out of the tech sphere ever since. </p>

      <p>Outside of tech I enjoy event organizing and art. I've organized for queer events, pride marches, and helped start the world's largest collegiate hackathon. I also produce music and write sometimes. I used to dance competitively.</p>

      <p>I’m currently on a hiatus, producing music, writing fiction, and occasionally hacking on tech while living in Berlin. I’ll be back in the game properly this fall in NYC. You can see what sort of opportunities I’m looking for <a href="/hire-me">here</a>. </p>
    </div>
  );
};

export default Home;
